var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ajaxDone
    ? _c(
        "div",
        {
          ref: "searchedAttachmentScrollBox",
          staticClass: "searched-attachment-list"
        },
        [
          _c("h1", {
            staticClass: "search-key",
            domProps: { textContent: _vm._s(_vm.$route.query.searchKey) }
          }),
          _vm._v(" "),
          _vm._l(_vm.AllAttachmentListList, function(attachment, index) {
            return _c(
              "section",
              {
                key: index,
                staticClass: "attachment-list box_search",
                class: _vm.$style["box_search"],
                on: {
                  click: function($event) {
                    return _vm.attachmentVisited(index)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "search-list-item",
                    on: {
                      click: function($event) {
                        return _vm.openFile(attachment.Url, attachment.Name)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "attachment-link" }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "attachment-content",
                      class: {
                        "attchment-visited": attachment.visited == true
                      },
                      domProps: { innerHTML: _vm._s(attachment.Name) }
                    })
                  ]
                )
              ]
            )
          }),
          _vm._v(" "),
          !_vm.AllAttachmentListList.length
            ? _c("div", { staticClass: "noData" }, [_vm._v("暂无数据")])
            : _vm._e(),
          _vm._v(" "),
          _c("loading-more")
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-34c0bc04", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-34c0bc04","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/search/attachmentList.vue
// module id = HF70
// module chunks = 2